import { render, staticRenderFns } from "./Abacus.vue?vue&type=template&id=56fc2849&scoped=true&lang=pug&"
import script from "./Abacus.vue?vue&type=script&lang=js&"
export * from "./Abacus.vue?vue&type=script&lang=js&"
import style0 from "./Abacus.vue?vue&type=style&index=0&id=56fc2849&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc2849",
  null
  
)

export default component.exports